var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"qrCodeCanvas",attrs:{"id":"qrCodeCanvas"}}),_c('img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"qrCodeImage",attrs:{"src":"","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }